import React from 'react';
import { useStore } from '../../../hooks/Store';

interface IUseProps {
    alt: string
    children: any
}

function Use({ alt, children }: IUseProps) {
    const { store, setStore } = useStore();

    return (
        <button
            className='text-link tag-use'
            onClick={(e) => {
                setStore({
                    ...store,
                    qestionInput: alt
                });
            }}>
            {children}
        </button>
    );
}

export default Use;
